import React from "react"

// Hooks
import { useTailSpacerMobile } from "../../hooks/useTailSpacerMobile"
import { useTailSpacerDesktop } from "../../hooks/useTailSpacerDesktop"

const PageSpacer = ({ mobileSize, deskSize, backgroundColor }) => {
  const mobSizeClass = useTailSpacerMobile(mobileSize)
  const deskSizeClass = useTailSpacerDesktop(deskSize)
  return (
    <section
      className={`${mobSizeClass} ${deskSizeClass} block`}
      style={{ backgroundColor: backgroundColor && backgroundColor.hex }}
    />
  )
}

export default PageSpacer
